
import { getIntegrationApp } from './integration-apps-utils.mjs'

export const makeCreateConfigurationFromUi = (type, subtype) => {
  const app = getIntegrationApp(type, subtype)
  if (!app) {
    return
  }
  return app.functions.createConfigurationFunc
}